import React, { useEffect } from 'reactn';
// import ReactGA4 from 'react-ga4';
// import TagManager from 'react-gtm-module'



export default function DataLayer({ product, category, products, itemLocation, list, metafields }) {

    // const tagManagerKeyKey = process.env.GATSBY_GOOGLE_TAG_MANAGER;
    // const gTagKey = process.env.GATSBY_GTAG_KEY;

    // const tagManagerArgs = {
    //     gtmId: tagManagerKeyKey
    // }
    // // const { pathname } = location
    // useEffect(() => {
    //     // ReactGA4.initialize(googleKey, { debug: false });
    //     // ReactGA4.initialize(gTagKey, { debug: false });
    //     // TagManager.initialize(tagManagerArgs)
    //     // ReactGA4.plugin.require('ecommerce')
    // }, [])
    
    function sendEvent(event, data) {
        console.log("DLSEND EVENT", event)
        // ReactGA4.event(event, data)
        window.dataLayer.push({event, eventModel: data})
    }
    useEffect(() => {
        if (product) {
            console.log("METAFIELDS", metafields)
            console.log("PRODUCT", product)
            if (list) {
                // alert("select_item")
                // PRODUCT CLICK FROM LIST         
                sendEvent(
                    'select_item',
                    {
                            item_list_id: list,
                            item_list_name: list,
                            items: [{
                                item_id: product.fields.sku,
                                item_name: product.title,
                                item_brand: "INGMARSON",
                                price: metafields.price,
                                currency: "GBP",
                                index: itemLocation,
                                item_list_name: list,
                                quantity: 1,
                                item_category: product.productType
                            }
                            ]
                    }
                );
                // alert("view_item2")
                sendEvent(
                    'view_item',
                    {
                            currency: 'GBP',
                            value: metafields.price,
                            items: [{
                                item_id: product.fields.sku,
                                item_name: product.title,
                                item_brand: "INGMARSON",
                                price: metafields.price,
                                currency: "GBP",
                                index: itemLocation,
                                item_list_name: list,
                                quantity: 1,
                                item_category: product.productType
                            }
                            ]
                    }
                );

                // ReactGA4.plugin.execute(
                //     'ecommerce',
                //     'setAction',
                //     'click', {
                //     'list': list
                // }
                // );
                // SEND THE PRODUCT CLICK
                // ReactGA4.pageview(pathname)
                // ReactGA4.send({ hitType: "pageview", pathname })
            } else {
                // alert("view_item1")
                sendEvent(
                    'view_item',
                    {
                            currency: 'GBP',
                            value: metafields.price,
                            items: [{
                                item_id: product.fields.sku,
                                item_name: product.title,
                                item_brand: "INGMARSON",
                                price: metafields.price,
                                currency: "GBP",
                                quantity: 1,
                                item_category: product.productType
                            }
                            ]
                        }
                );
            }

            
            // // PRODUCT VIEW - ALWAYS
            // ReactGA4.plugin.execute(
            //     'ecommerce',
            //     'addProduct',
            //     {
            //         id: sku,
            //         name: title,
            //         brand: "INGMARSON",
            //         price: metafields.price,
            //         currency: "GBP",
            //         category: category
            //     }
            // );
            // ReactGA4.plugin.execute('ecommerce', 'setAction', 'detail');
        }

    }, [product, list])

    useEffect(() => {
        if (products) {
            // alert("view_item_list")
            const productsCount = products.length > 20 ? 20 : products.length
            // const productsCount = products.length 
            // NEED TO LIMIT IMPRESSIONS TO 10 to keep page size under 8192
            var items = []
            for (var count = 0; count < productsCount; count++) {
                const product = products[count]
                if (sku) {
                    items.push({
                        item_id: sku,
                        item_name: title,
                        item_brand: "INGMARSON",
                        item_list_name: list,
                        index: __position,
                        quantity: 1,
                        price: price,
                        currency: "GBP",
                        item_category: category
                    })
                }
                // console.log("XXXXAADDXXX", product)
                const { title, sku, slugCategory, price, __position } = product
                ;


                // console.log("PAGEVIEW PRODUCTS: ", items)
                // ReactGA4.send("pagevidw", pathname)
                // ReactGA4.send({ hitType: "pageview", pathname })
            }
            sendEvent(
                'view_item_list',
                {
                        item_list_id: list,
                        item_list_name: list,
                        items: items
                }
            )
        }
    }, [products])

    // useEffect(() => {
    //     // console.log("PAGEVIEW LOCATION: ", pathname)
    //     // ReactGA4.pageview(pathname)
    //     ReactGA4.send({ hitType: "pageview", pathname })
    // }, [location])


    return (
        <></>
    )
}